// import parseTime, formatTime and set to filter
export { parseTime, formatTime } from '@/utils'

import store from '@/store'
/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

// 时间戳格式化
export function timeFormat (val, type) {
  if (!val) return '--'
  function add0 (m) { return m < 10 ? '0' + m : m }
  var time = new Date(val);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  if (type == 'date') return y + '/' + add0(m) + '/' + add0(d)
  return y + '/' + add0(m) + '/' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
}


// 数字处理 小数点/单位/缩小 小于min不显示
export function handleNum(num, decimal = 0, unit = ' ', enlarge = 100, min) {
  if (num && (typeof num === 'number') && !isNaN(num)) {
    const value = num / enlarge
    if (min) {
      if (value >= min) {
        return value.toFixed(decimal) + unit
      }
    } else {
      return value.toFixed(decimal) + unit
    }
  }
  return '--'
}
// 统一温度处理， 温度转换
export function handleTem(val, diff) {
  if (val == '--') return '--'
  if (val || val == 0) {
    // dc 电池温度
    if (val > 10000) val = -(val - 10000)

    if (diff) {
      val = (val / diff).toFixed(0)
    } else {
      if (val > 150 || val < -150) {
        val = (val / 100).toFixed(0)
      }
    }

    if (store.state.temType == 'hsd') {
      return (val * 1.8 + 32).toFixed(0) + '℉'
    }
    return val + '℃'
  }
  return '--'
}
